export const LOGO = "/logo-2elab.png";
export const LOGO_DARK = "https://customer-assets.emergentagent.com/job_strategy-shop/artifacts/lzwipdrj_logo.png";

export const NAV = [
  { to: "/chi-sono", label: "Chi sono" },
  { to: "/servizi", label: "Servizi" },
  { to: "/editoriale", label: "Editoriale" },
  { to: "/contatti", label: "Contatti" },
];

export const SERVICES = [
  { n: "01", title: "Branding & Posizionamento", desc: "Identità di marca: posizionamento, valori, tono di voce, identità visiva e linee guida. Non un logo. Un sistema." },
  { n: "02", title: "Strategia Marketing & Comunicazione", desc: "Analisi del campo competitivo e piano strategico: obiettivi, target, canali, messaggi chiave, KPI di monitoraggio." },
  { n: "03", title: "Social Media Strategy & Piano Editoriale", desc: "Audit dei canali, piano editoriale: temi guida, tono di voce, formati, calendario. Pubblicare con metodo, non a sensazione." },
  { n: "04", title: "Consulenza Sito Web", desc: "Architettura informativa, UX, contenuti, posizionamento. Supervisione strategica dello sviluppo, non lo sviluppo tecnico." },
  { n: "05", title: "Strategia di Vendita & Strumenti Commerciali", desc: "Processo di vendita, pitch deck, schede prodotto, script, materiali di presentazione. Non slide convincenti: strumenti che chiudono." },
  { n: "06", title: "Processi & Sistemi Gestionali", desc: "Valutazione e migrazione gestionale, controllo dei KPI operativi, supervisione continua dei processi." },
];

export const JOURNAL = [
  { tag: "PUNTI DI VISTA", title: "Sorry, non sono il tuo guru.", excerpt: "Il settore vende certezze. Io vendo metodo. La differenza è che il metodo lo puoi verificare." },
  { tag: "DOMANDE SOCRATICHE", title: "Cosa stai vendendo davvero?", excerpt: "Se la risposta è \"qualità e passione\", non hai ancora risposto. Hai elencato il minimo sindacale." },
  { tag: "PUNTI DI VISTA", title: "L'AI non ti salva dal pensare.", excerpt: "Con metodo, non con l'AI al posto del cervello. Gli strumenti amplificano una strategia, non la sostituiscono." },
  { tag: "DOMANDE SOCRATICHE", title: "Perché un cliente dovrebbe scegliere te?", excerpt: "\"Perché sono il migliore\" non è un posizionamento. È un'opinione non verificata." },
];

export const CONTACT = {
  email: "v.g.2esource@twoelab.cloud",
  phone: "+39 349 56 62 852",
  instagram: "@twoelab",
  instagramUrl: "https://instagram.com/twoelab",
};
